<div class="chart-filters">
	<div style="display: inline-block !important;margin-top: 13px;padding: 0px !important;margin-right: 24px;">
    	<button mat-button disabled color="primary">{{translations.lblDistributorFilter}}</button>
	</div>
	<mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="40">
	        <mat-select #inpDistributor [(ngModel)]="distributorId">
	        	<mat-option *ngIf="distributorList.length > 1"  [value]="0">All</mat-option>
	            <mat-option *ngFor="let distributor of distributorList" [value]="distributor.Id">{{distributor.Name}}</mat-option>
	        </mat-select>
	</mat-form-field>
	<div style="display: inline-block !important;margin-top: 13px;padding: 0px !important;margin-right: 24px;">
    	<button mat-button disabled color="primary">{{translations.lblOrderDateColumnFilter}}</button>
	</div>
	<mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="40">
	        <mat-select #inpOrderDateColumns [(ngModel)]="orderDateColumnId">
	            <mat-option *ngFor="let orderDateColumn of orderDateColumnList" [value]="orderDateColumn.Id">{{orderDateColumn.Text}}</mat-option>
	        </mat-select>
	</mat-form-field>
	<div style="display: inline-block !important;margin-top: 8px;padding: 0px !important;">
    	<button mat-raised-button color="primary" (click)="updateGraph()" >{{translations.btnUpdateGraph}}</button>
	</div>
</div>
<div class="chart-container">
	<dx-chart id="chart" [title]="graphTitle" [dataSource]="orders" (onPointClick)="onPointClick($event)">
		<dxo-size [height]="525"></dxo-size>
	    <dxi-series valueField="LastYear" [name]="years.length > 0 ? years[0] : 0"></dxi-series>
	    <dxi-series valueField="CurrentYear" [name]="years.length > 1 ? years[1] : 0"></dxi-series>
	    <dxo-common-series-settings argumentField="Month" type="bar" hoverMode="allArgumentPoints" selectionMode="allArgumentPoints">
	        <dxo-label [visible]="true" [format]="{ type: 'fixedPoint', precision: '0' }"></dxo-label>
	    </dxo-common-series-settings>
	    <dxo-legend verticalAlignment="bottom" horizontalAlignment="center"></dxo-legend>
	    <dxo-export [enabled]="true"></dxo-export>
	</dx-chart>
</div>



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/dashboard/order-chart/order-chart.component.html